"use client";

import { usePathname } from "next/navigation";
import Tabs, { TAB_STYLE, TabItem } from "@/components/common/Tab";
import SubpageBackground from "@/components/common/SubpageBackground";
import PageTitle from "@/components/common/PageTitle";

export default function ResourceLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const tabs: TabItem[] = [
    {
      id: "1",
      name: "Singapore",
      value: "/contact/singapore",
      href: "/contact/singapore",
    },
    {
      id: "2",
      name: "Thailand",
      value: "/contact/thailand",
      href: "/contact/thailand",
    },
    {
      id: "3",
      name: "Vietnam",
      value: "/contact/vietnam",
      href: "/contact/vietnam",
    },
    {
      id: "4",
      name: "Global",
      value: "/contact/global",
      href: "/contact/global",
    },
  ];

  // Hide the location tab bar on non-country routes (e.g. /contact/thank-you).
  const showTabs = tabs.some((t) => t.value === pathname);

  // Determine the title based on the current path
  const getTitle = () => {
    return "Business Location";
  };

  return (
    <div className="relative min-h-screen flex flex-col bg-background pb-16 sm:pb-[120px]">
      {/* Decorative background moved to `next/image` to reduce CLS. */}
      <SubpageBackground />

      {/* Foreground Content */}
      <div className="relative z-10 flex flex-col flex-1">
        {/* Title and Tab Section */}
        {showTabs && (
          <div className="w-full px-4 sm:px-6 lg:px-8">
            <section className="w-full max-w-[1300px] mx-auto pb-6 pt-[112px] md:pt-[128px] md:pb-[48px]">
              {/* One fixed title ("Business Location"), so nothing ever transitions
                  here — PageTitle is used for the shared heading style alone. */}
              <PageTitle className="mb-4 md:mb-6">{getTitle()}</PageTitle>

              {/* Tab Navigation */}
              <Tabs
                tabs={tabs}
                currentValue={pathname}
                style={TAB_STYLE.STYLE_1}
                showContent={false}
                useRouter={true}
                customClassName="[&>a:first-child]:!pl-0"
              />
            </section>
          </div>
        )}

        {/* Page Content */}
        <main className="flex-1 w-full">{children}</main>
      </div>
    </div>
  );
}
